import * as types from "./mutation-types";
import { merge } from "lodash";
import { contrapartida_modelo_empty } from "./getters";

export default {
  [types.SET_CONTRAPARTIDAS](state, payload) {
    state.contrapartidas = payload;
  },
  [types.SET_CONTRAPARTIDA](state, payload) {
    payload = merge(contrapartida_modelo_empty(), payload);
    state.contrapartida = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
